<section class="operator-workspace-section" aria-labelledby="operator-workspace-heading">
  <div class="container">
    <div class="operator-workspace">
      <div class="operator-copy">
        <p class="exclusive-eyebrow">Exclusive to Operator</p>
        <h2 id="operator-workspace-heading">Run every organization you support from one workspace</h2>
        <p class="operator-description">
          Operator Workspace is the dedicated operating layer for teams responsible for multiple member organizations—not a required upgrade for every MemberTrace customer.
        </p>
      </div>

      <div class="operator-actions">
        <div class="operator-signal" *ngFor="let capability of capabilities">
          <mat-icon aria-hidden="true">{{ capability.icon }}</mat-icon>
          <span>{{ capability.label }}</span>
        </div>
        <div class="operator-buttons">
          <a mat-flat-button
             color="primary"
             routerLink="/contact"
             [queryParams]="{ inquiryType: 'pricing', plan: 'operator' }"
             (click)="onOperatorCta()">
            Talk to sales
          </a>
          <a mat-stroked-button color="primary" routerLink="/for-operators">See operator use case</a>
        </div>
      </div>
    </div>
  </div>
</section>
